import {EMTPY_FUND_VALUATION_SENSITIVITY_OVERVIEW, FundValuationSensitivityOverview} from "../../models/fund-valuation-sensitivity-overview";
import {ApiDataModel} from "../../../shared/model/api-data-model";
import {EMTPY_FUND_VALUATION_SENSITIVITY, FundValuationSensitivity} from "../../models/fund-valuation-sensitivity";

export const ALL_CASE_TOKENS = ["weighted", "low", "base", "high"] as const;
export const ALL_PERF_TOKENS = ["netPerf", "grossPerf", "nav", "finalPrimary"] as const;
export const DEFAULT_COLUMN_TOKENS: string[] = ALL_CASE_TOKENS.flatMap(c =>
    ALL_PERF_TOKENS.map(p => `${c}_${p}`)
);

export const COLUMN_TOKENS_STORAGE_KEY = "valumize.fv-sensitivity.columnTokens";

function loadPersistedColumnTokens(): string[] {
    try {
        const raw = localStorage.getItem(COLUMN_TOKENS_STORAGE_KEY);
        if (raw) {
            const parsed = JSON.parse(raw);
            if (Array.isArray(parsed) && parsed.every((t: unknown) => typeof t === "string")) return parsed;
        }
    } catch { /* ignore malformed data */ }
    return DEFAULT_COLUMN_TOKENS;
}

export interface FvSensitivityState {
    fundValuationSensitivityOverview: ApiDataModel<FundValuationSensitivityOverview>;
    fundValuationSensitivity: ApiDataModel<FundValuationSensitivity>;
    selectedColumnTokens: string[];
}

export const INITIAL_STATE: FvSensitivityState = {
    fundValuationSensitivityOverview: {
        data: EMTPY_FUND_VALUATION_SENSITIVITY_OVERVIEW,
        status: "INIT",
        errorMessage: ""
    },
    fundValuationSensitivity: {
        data: EMTPY_FUND_VALUATION_SENSITIVITY,
        status: "INIT",
        errorMessage: ""
    },
    selectedColumnTokens: loadPersistedColumnTokens(),
};
